import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
} from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useRecoilState } from "recoil";

import {
  ProduceButtonsPageViewMode,
  produceButtonsPageViewModeAtom,
} from "@ryde/shared";

export const ProduceButtonsViewModeSwitch: FC = () => {
  const { t } = useTranslation();

  const [viewType, setViewType] = useRecoilState(
    produceButtonsPageViewModeAtom,
  );

  const handleViewTypeChange = (
    event: SelectChangeEvent<ProduceButtonsPageViewMode>,
  ): void => {
    setViewType(event.target.value as ProduceButtonsPageViewMode);
  };

  return (
    <FormControl sx={{ minWidth: 210 }} size="small" variant="standard">
      <Select
        data-e2e="produce-buttons-page-view-mode-select"
        value={viewType}
        onChange={handleViewTypeChange}
      >
        <MenuItem value={ProduceButtonsPageViewMode.ViewButtonsOfToday}>
          {t("selectListLabel.ViewButtonsOfToday")}
        </MenuItem>
        <MenuItem value={ProduceButtonsPageViewMode.ViewAllButtons}>
          {t("selectListLabel.ViewAllButtons")}
        </MenuItem>
      </Select>
    </FormControl>
  );
};
